import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { HighRisk as HighRiskComponent } from "ui/organizms/Onboarding";

const HighRisk = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Onboarding | Applications | High Risk'
    >
        <HighRiskComponent />
    </Screen>
);

export default memo(HighRisk);
